import gql from 'graphql-tag';

export default gql`
  mutation ($id: MongoID!, $title: String, $content: String, $startDate: Date, $endDate: Date, $image: String) {
    updateAnnounce(
      _id: $id
      record: { title: $title, content: $content, startDate: $startDate, endDate: $endDate, image: $image }
    ) {
      recordId
    }
  }
`;
